import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { PasswordResetControllerService } from '../api/index.ts';
import './ForgotPassword.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Honeypot — pole niewidoczne dla użytkownika, wypełniane tylko przez boty
  const honeypotRef = useRef('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Honeypot check — jeśli wypełnione, cicho zablokuj
    if (honeypotRef.current) {
      setSuccessMessage('Jeśli podany adres email jest zarejestrowany w naszym systemie, link do resetowania hasła został wysłany.');
      return;
    }

    if (!email) {
      setError('Wprowadź adres email');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      await PasswordResetControllerService.forgotPassword({ email: email.trim() });
    } catch {
      // Celowo ignorujemy błędy — nie ujawniamy czy email istnieje w systemie
    } finally {
      setIsLoading(false);
      setSuccessMessage('Jeśli podany adres email jest zarejestrowany w naszym systemie, link do resetowania hasła został wysłany.');
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <h1>Resetowanie hasła</h1>
          <p>Podaj adres email użyty podczas rejestracji</p>
        </div>

        <form onSubmit={handleSubmit} className="forgot-password-form">
          {error && <div className="error-message">{error}</div>}
          {successMessage && <div className="success-message-box">{successMessage}</div>}

          {!successMessage && (
            <>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(''); }}
                  placeholder="Wprowadź adres email"
                  autoComplete="email"
                  maxLength={100}
                />
              </div>

              {/* Honeypot — ukryte pole anty-bot */}
              <div style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, overflow: 'hidden' }} aria-hidden="true">
                <label htmlFor="website">Website</label>
                <input
                  type="text"
                  id="website"
                  name="website"
                  tabIndex={-1}
                  autoComplete="off"
                  onChange={(e) => { honeypotRef.current = e.target.value; }}
                />
              </div>

              <button type="submit" className="btn btn-primary btn-forgot" disabled={isLoading}>
                {isLoading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
              </button>
            </>
          )}
        </form>

        <div className="forgot-password-footer">
          <Link to="/login" className="back-to-login-link">
            Powrót do logowania
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
